import { inject, injectable } from "inversify";
import type {
	ISeoInfoBase,
	ISeoFilterState,
	IOrganisationSearchApplicationState,
	ISeoSortingState
} from "@studyportals/fawkes/organisations-search-seo";

import {
	SearchIndexabilityManager,
	types
} from "@studyportals/fawkes/organisations-search-seo";


@injectable()
export class Indexability {

	private indexabilityManager: SearchIndexabilityManager;

	public constructor(
		@inject(types.SeoInfoBase) seoInfoBase: ISeoInfoBase,
		@inject(types.SeoFilterState) seoFilterState: ISeoFilterState,
		@inject(types.SeoApplicationState) applicationState: IOrganisationSearchApplicationState,
		@inject(types.SeoSortingState) seoSortingState: ISeoSortingState
	) {
		this.indexabilityManager = new SearchIndexabilityManager(
			window.PortalType,
			seoInfoBase,
			seoFilterState,
			seoSortingState,
			applicationState
		);
	}

	public shouldIndex(): Promise<boolean> {
		return this.indexabilityManager.shouldIndex();
	}
}
